"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useNavigation() {
    const history = (0, react_router_dom_1.useHistory)();
    const { state } = (0, react_router_dom_1.useLocation)();
    const [prompts, setPrompts] = (0, react_1.useState)([]);
    const dialogRef = (0, react_1.useRef)(null);
    const callbackRef = (0, react_1.useRef)();
    const navigateInternal = (0, event_callback_hook_1.useEventCallback)((url, replace, state) => {
        if (replace) {
            history.replace(url, state);
        }
        else {
            history.push(url, state);
        }
    });
    const testPrompts = (0, event_callback_hook_1.useEventCallback)((callback) => {
        var _a;
        if (prompts.length > 0) {
            callbackRef.current = callback;
            (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.open();
        }
        else {
            callback();
        }
    });
    const navigate = (0, event_callback_hook_1.useEventCallback)((url, replace = false, state = undefined) => {
        testPrompts(() => {
            navigateInternal(url, replace, state);
        });
    });
    const registerPrompt = (0, event_callback_hook_1.useEventCallback)((prompt) => {
        if (!prompts.includes(prompt)) {
            setPrompts([...prompts, prompt]);
        }
    });
    const unregisterPrompt = (0, event_callback_hook_1.useEventCallback)((prompt) => {
        if (prompts.includes(prompt)) {
            setPrompts(prompts.filter((p) => p !== prompt));
        }
    });
    const promptConfirm = (0, event_callback_hook_1.useEventCallback)(() => {
        const callback = callbackRef.current;
        callbackRef.current = undefined;
        prompts.forEach((prompt) => prompt.clearCallback !== undefined && prompt.clearCallback());
        setPrompts([]);
        callback();
    });
    const promptCancel = (0, event_callback_hook_1.useEventCallback)(() => {
        callbackRef.current = undefined;
    });
    const context = (0, react_1.useMemo)(() => ({
        prompts,
        navigate,
        testPrompts,
        registerPrompt,
        unregisterPrompt,
        stateAction: state != null ? state : null,
    }), [prompts, navigate, testPrompts, registerPrompt, unregisterPrompt, state]);
    return { context, dialogRef, prompts, promptConfirm, promptCancel };
}
exports.useNavigation = useNavigation;
//# sourceMappingURL=navigation-hook.js.map